import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    loadNotDefinedOnVehicle: translate({
      id: 'rm.scheduler.popOver.loads.loadNotDefinedOnVehicle',
    }),

    noLoad: translate({ id: 'rm.scheduler.popOver.loads.noLoad' }),
  }))

  return api
}
